import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CourseService } from '../../../_services/course.service';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../_services/global.service';
import { ResponseStructure } from '@iq-central-front-end/share';
import { ToastrService } from 'ngx-toastr';
import { IDeactivateComponent } from '../../../_models/i-deactivate';

@Component({
  selector: 'iq-central-front-end-edit-lesson',
  templateUrl: './edit-lesson.component.html',
  styleUrls: ['./edit-lesson.component.scss'],
})
export class EditLessonComponent implements OnInit, OnDestroy, AfterViewInit {
  sub: Subscription = new Subscription();
  isLoading: boolean;
  @ViewChild('lessonName') lessonName: ElementRef;
  lessonForm: FormGroup;
  lessonFormEdit: FormGroup;
  lessons: any[] = [];
  courseCode: any;
  lessonId: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _course: CourseService,
    private fb: FormBuilder,
    private _global: GlobalService,
    private _toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.initLessonForm();
    this.initLessonFormEdit();
    this.courseCode = this.route.snapshot.paramMap.get('code');

    this.route.data.subscribe((res) => {
      this.lessons = res['resolvedData'].responseResult;
      // this.lessonContents =
      //   res['resolvedData'].responseResult[0]['lessonContents'];
    });
  }

  ngAfterViewInit() {
    this.lessonName.nativeElement.focus();
  }
  initLessonForm() {
    this.lessonForm = this.fb.group({
      title: ['', Validators.required],
    });
  }

  initLessonFormEdit() {
    this.lessonFormEdit = this.fb.group({
      title: ['', Validators.required],
    });
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  addLessonContent(route?) {
    this.isLoading = true;
    const payload = this.lessonForm.value;
    payload.courseCode = this.courseCode;

    this.sub.add(
      this._course.createLesson(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.lessonId = res.responseResult['id'];
          this.isLoading = false;
          if (route) {
            this._global.hideSpinner();
            this.router.navigate(['courses/course-details', this.courseCode]);
          } else {
            this.router.navigate([
              'courses/select-lesson-type',
              this.lessonId,
              this.courseCode,
            ]);
          }
        },
      })
    );
  }
  finish(route) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This lesson will be saved and you will be taken to your course details',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        this._global.showSpinner();
        this.addLessonContent(route);
      }
    });
  }
  addContent(id) {
    this.router.navigate(['courses/select-lesson-type', id, this.courseCode]);
  }

  deleteLessonContent(id, index) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be deleted and cannot be undone',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
    }).then((result) => {
      if (result.value) {
        this.deleteContent(id, index);
      }
    });
  }

  editVideo(id, contentId) {
    this.router.navigate([
      'courses/edit-video/',
      id,
      this.courseCode,
      contentId,
    ]);
  }
  editQuiz(id) {
    this.router.navigate(['courses/edit-quiz/', id, this.courseCode]);
  }
  editPdf(id, contentId) {
    this.router.navigate(['courses/edit-pdf/', id, this.courseCode, contentId]);
  }

  deleteContent(id, index) {
    this._global.showSpinner();
    this._course.deletecontent(id).subscribe({
      next: (res: ResponseStructure) => {
        this.lessons[index].lessonContents = this.lessons[
          index
        ].lessonContents.filter((content) => content.id !== id);
        this._global.globalSuccessHandler(res);
      },
    });
    this.sub.add();
  }

  deleteLesson(lessonId) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This lesson and all its content will be deleted and cannot be undone',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE;',
      cancelButtonColor: '#1CB4AE;',
      confirmButtonText: 'Delete',
    }).then((result) => {
      if (result.value) {
        this._global.showSpinner();
        this.sub.add(
          this._course.deleteLesson(this.courseCode, lessonId).subscribe({
            next: (res: ResponseStructure) => {
              this.lessons = this.lessons.filter((l) => l.id !== lessonId);
              this._global.globalSuccessHandler(res);
            },
          })
        );
      }
    });
  }
  editLesson(i) {
    const element = document.getElementById('edit' + i);
    const inputTitle = document.getElementById('input' + i);
    inputTitle['readOnly'] = false;
    element.style.backgroundColor = '#ffffff';
    element.style.border = '2px solid #1CB4AE';
    inputTitle.style.border = '2px solid #ccc';
    element.style.paddingLeft = '10px';
    element.focus();
    let visibleLabel = document.getElementById('visible' + i);
    visibleLabel.style.visibility = 'visible';
  }

  default(i) {
    const element = document.getElementById('edit' + i);
    const inputTitle = document.getElementById('input' + i);
    inputTitle['readOnly'] = true;
    element.style.backgroundColor = 'transparent';
    element.style.border = 'none';
    inputTitle.style.border = 'none';
    let visibleLabel = document.getElementById('visible' + i);
    visibleLabel.style.visibility = 'hidden';
  }

  updateLessonName(lessonId, i) {
    const payload = this.lessonFormEdit.value;
    payload.courseCode = this.courseCode;
    this.sub.add(
      this._course.updateLesson(lessonId, payload).subscribe({
        next: (res: ResponseStructure) => {
          this.default(i);
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: 'success',
            title: 'Lesson name updated successfully',
          });
        },
      })
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
